import { useCallback, useState } from 'react';

function usePage(
  defaultPage = 0
): [number, (selectedItem: { selected: number }) => void, () => void] {
  const [page, updatePage] = useState<number>(defaultPage);

  const setPage = useCallback(
    (selectedItem: { selected: number }) => updatePage(selectedItem.selected),
    []
  );

  const resetPage = useCallback(() => updatePage(0), []);

  return [page, setPage, resetPage];
}

export default usePage;
